PJQ.modules.files = {
	routes: [],
};

PJQ.app.addRoutes(PJQ.modules.files.routes);